import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rm-changing-support-settings-modal',
  templateUrl: './changing-support-settings-modal.html',
  styleUrls: ['./changing-support-settings-modal.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalModule, ButtonV2Module, TranslatePipe, TranslateDirective],
})
export class ChangingSupportSettingsModal {
  private readonly modalRef = inject(ModalRef);

  public width: string = '650px';
  public height: string = '300px';

  public changeSupportSettings(): void {
    this.modalRef.emitAndClose(true);
  }

  public abort(): void {
    this.modalRef.emitAndClose(false);
  }
}
